<script>
export default {
    name: 'header-section',

    props: {
        paddingValue: {
            type: String,
            default: 'auto'
        },

        title: {
            type: String,
            default: ''
        }
    }
};
</script>

<template>
    <div class="header-section">
        <div class="header-section__inside" :style="{ padding: paddingValue }">
            <slot name="title">
                <h4 class="header-section__title">
                    {{ title }}
                </h4>
            </slot>
        </div>

        <slot />
    </div>
</template>
